import React, { lazy } from "react";
import backgroundImg from "../images/BG-hands.webp";
import SearchBar from "../components/SearchBar";
import { CustomLink } from "../components/CustomLink";
import { stringToPath } from "../lib/stringToPath";

const LazyFooter = lazy(() => import("../components/Footer"));
const LazyHeader = lazy(() => import("../components/Header"));

const AlphabeticalSubCategories = ({ pageContext }) => {
  const charityType = pageContext?.title;
  const numberWithCommas = pageContext?.count;
  const catUrl = pageContext?.url;
  const categories = pageContext?.subCategories;
  const catName = Object.keys(categories);
    
  return (
    <div>
      <LazyHeader />
      <div>
        <div
            className="w-full px-7 pb-[30px] pt-10 lg:min-h-[300px] lg:px-2 lg:pt-[60px] xl:px-28 2xl:px-32 "
            style={{
              backgroundImage: `url(${backgroundImg})`,
              backgroundSize: "cover"
            }}
          >
          <h1 className="text-center text-2xl font-bold lg:text-5xl ">
            There {numberWithCommas === 1 ? "is" : "are"} {numberWithCommas}{" "}
            <span className="capitalize">
              {charityType?.includes("charities") ? charityType?.replace("Medium", "medium-sized") : charityType }
            </span>
            {charityType?.includes("charities")
                ? ""
                : numberWithCommas === 1
                  ? " Nonprofit"
                  : " Nonprofits"}
          </h1>

          <div className="mt-7 w-full">
            <SearchBar />
          </div>
        </div>

        <div className=" my-2 bg-white p-7 lg:px-28 xl:px-28 2xl:px-32 ">
          <div className="">
            <h2 className="my-[10px] pb-4 text-center text-3xl font-semibold text-[#4D4D4D] md:text-4xl lg:mt-7">
              Find by Name
            </h2>
            <div
                className="bg-[#88d8b540] p-2 "
                style={{ boxShadow: "0px 8px 40px 0px rgba(0, 0, 0, 0.10)" }}
              >
              <ul>
                {catName?.map((subcategory, index) => (
                  <CustomLink
                      href={`${catUrl}-${index+1}`}
                      key={stringToPath(subcategory)}
                    >
                    <li className="m-2 grid cursor-pointer grid-cols-9 justify-start rounded-[7px]  bg-white p-2 text-lg transition-all hover:bg-primary">
                      <p className="col-span-2 text-xl font-medium text-[#0D82EE]">{subcategory} </p>
                      <small className="col-span-3"> { categories[subcategory][0].name }</small>
                      <p className="text-center"> - </p>
                      <small className="col-span-3"> { categories[subcategory].slice(-1)[0].name } </small>
                    </li> 
                  </CustomLink>
                  ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="my-6 flex flex-col-reverse px-7 md:my-2 md:flex-row md:justify-between lg:px-28 xl:px-28 2xl:px-32 ">
          <CustomLink href="/" className="flex justify-center md:justify-start">
            <button type="button" className="flex justify-center rounded-lg bg-primary p-4 text-lg  font-semibold  shadow-[0px_4px_10px_0px_#00000026]">
              EXPLORE OTHER CHARITIES
            </button>
          </CustomLink>
        </div>
      </div>
      <LazyFooter />
    </div>
  );
};

export default AlphabeticalSubCategories;

export const Head = ({pageContext}) => 
  <>
    <title>{pageContext.pgTitle}</title>
    <meta name="description" content={`Alphabetical listing of ${pageContext?.title.toLowerCase()} ${pageContext?.mainCategory ? "nonprofits " : ""}from ${pageContext.subCat.replace(" - ", "-")}`.replace("medium", "medium-sized") } />
  </>
